export const STUDENT_LINKS = [
  {
    id: '1',
    name: 'SIDEBAR.DASHBOARD',
    icon: 'fa-solid fa-house ms-2',
    link: '/student/dashboard',
  },
  {
    id: '2',
    name: 'CRUMBS.TESTS',
    icon: 'fa-solid fa-pen-ruler ms-2',
    // Une seule entrée : l'espace tests réunit désormais diagnostic,
    // entraînement, devoirs et copies sur une page. Le sous-menu dédoublait
    // une même grille et obligeait à choisir un type de test avant même
    // d'avoir choisi une matière.
    link: '/student/tests',
    // Les entrées élève déclarent la fonctionnalité de pack qui les ouvre
    // (SKILL2ERA-137) : la même clé que la route et que le serveur. L'espace
    // tests s'ouvre à l'un des trois types de test — l'une suffit.
    feature: ['diagnostic', 'practice', 'exams'],
  },
  {
    id: '4',
    name: 'SIDEBAR.COURSES',
    icon: 'fa-solid fa-tv ms-2',
    link: '/student/courses',
    // Pas de fonctionnalité de pack : la page est encore vide, elle reste
    // ouverte à tous jusqu'à ce qu'elle ait un contenu.
  },
  {
    id: '5',
    name: 'SIDEBAR.LIBRARY',
    icon: 'fa-solid fa-book ms-2',
    link: '/student/library',
    feature: 'library',
  },
  {
    id: '6',
    name: 'SIDEBAR.HOMEWORK',
    icon: 'fa-solid fa-file-invoice ms-2',
    link: '/student/homework',
    feature: 'homework',
  },
  {
    id: '6b',
    name: 'PROFILE.TITLE',
    icon: 'fa-solid fa-id-card ms-2',
    link: '/student/profile',
  },
  {
    id: '7',
    name: 'SIDEBAR.TREATMENT',
    icon: 'fa-solid fa-check-to-slot ms-2',
    link: '/student/planning',
    // Page encore vide : ouverte à tous, hors des fonctionnalités de pack.
  },
  {
    id: '8',
    name: 'SIDEBAR.CONSULT',
    icon: 'fa-regular fa-comment-dots ms-2',
    hasSubmenu: true,
    submenu: [
      {
        id: '8-1',
        name: 'SIDEBAR.CONSULT',
        icon: 'fa-regular fa-comment-dots',
        link: '/student/consultations',
        // Page encore vide : ouverte à tous, hors des fonctionnalités de pack.
      },
      {
        id: '8-2',
        name: 'SIDEBAR.APPOINTMENTS',
        icon: 'fa-solid fa-calendar-alt',
        link: '/student/agenda',
        feature: 'agenda',
      },
    ],
  },
  {
    id: '9',
    name: 'SIDEBAR.ASSISTANCE',
    icon: 'fa-solid fa-circle-question ms-2',
    link: '/student/assistance',
    feature: 'assistance',
  },
];

// constants.ts - Updated TEACHER_LINKS
export const TEACHER_LINKS = [
  {
    id: '1',
    name: 'SIDEBAR.DASHBOARD',
    icon: 'fa-solid fa-house ms-2',
    link: '/teacher/dashboard',
  },
  {
    id: '2',
    name: 'SIDEBAR.BANK',
    icon: 'fa-solid fa-floppy-disk ms-2',
    link: '/teacher/tests',
    hasSubmenu: true,
    submenu: [
      {
        id: '2-1',
        name: 'SIDEBAR.TESTS',
        icon: 'fa-solid fa-graduation-cap',
        link: '/teacher/tests/bank',
      },
      {
        id: '2-2',
        name: 'SIDEBAR.QUESTION_BANK',
        icon: 'fa-solid fa-database',
        link: '/teacher/question-bank',
      },
      {
        id: '2-3',
        name: 'SIDEBAR.REVIEW_QUEUE',
        icon: 'fa-solid fa-clipboard-check',
        link: '/teacher/review-queue',
      },
      {
        id: '2-4',
        name: 'SIDEBAR.THEMES',
        icon: 'fa-solid fa-layer-group ms-2',
        link: '/teacher/tests/themes',
      },
    ],
  },
  {
    id: '3',
    name: 'SIDEBAR.DAILY_OP',
    icon: 'fa-solid fa-qrcode ms-2',
    link: '/teacher/operations',
  },
  {
    id: '4',
    name: 'SIDEBAR.FOLLOW_STD',
    icon: 'fa-solid fa-desktop ms-2',
    link: '/teacher/my-students',
  },
  {
    id: '4b',
    name: 'SIDEBAR.GROUPS',
    icon: 'fa-solid fa-users ms-2',
    link: '/teacher/groups',
  },
  {
    id: '4c',
    name: 'SIDEBAR.ASSIGNMENTS',
    icon: 'fa-solid fa-clipboard-list ms-2',
    link: '/teacher/assignments',
  },
  {
    id: '4d',
    name: 'SIDEBAR.CALENDAR',
    icon: 'fa-solid fa-calendar-days ms-2',
    link: '/teacher/calendar',
  },
  {
    id: '5',
    name: 'SIDEBAR.LIBRARY',
    icon: 'fa-solid fa-book ms-2',
    link: '/teacher/library',
  },
  {
    id: '6',
    name: 'SIDEBAR.HOMEWORK',
    icon: 'fa-solid fa-file-invoice ms-2',
    link: '/teacher/certificates',
  },
  {
    id: '6b',
    name: 'SIDEBAR.ASSISTANCE',
    icon: 'fa-solid fa-circle-question ms-2',
    link: '/teacher/assistance',
  },
  {
    id: '7',
    name: 'SIDEBAR.CONSULT',
    icon: 'fa-regular fa-comment-dots ms-2',
    hasSubmenu: true,
    submenu: [
      {
        id: '7-1',
        name: 'SIDEBAR.ACADEMIC_FOLLOWING',
        icon: 'fa-solid fa-graduation-cap',
        link: '/teacher/consultations/academic-following',
      },
      {
        id: '7-2',
        name: 'SIDEBAR.MEDICAL_FILE',
        icon: 'fa-solid fa-notes-medical',
        link: '/teacher/consultations/medical-file',
      },
      {
        id: '7-3',
        name: 'SIDEBAR.BEHAVIOR_REPORT',
        icon: 'fa-solid fa-user-check',
        link: '/teacher/consultations/behavior-report',
      },
      {
        id: '7-4',
        name: 'SIDEBAR.PARENT_COMMUNICATION',
        icon: 'fa-solid fa-users',
        link: '/teacher/consultations/parent-communication',
      },
      {
        id: '7-5',
        name: 'SIDEBAR.ATTENDANCE_REPORT',
        icon: 'fa-solid fa-calendar-check',
        link: '/teacher/consultations/attendance-report',
      },
    ],
  },
];

/**
 * Menu de l'espace d'administration, groupé par domaine.
 *
 * <p>Il comptait dix-neuf entrées à plat, plus celles que les permissions
 * d'inspection y ajoutaient : une colonne qu'il fallait parcourir en entier
 * pour trouver quoi que ce soit, et où « Matières », « Modules » et « Parcours »
 * voisinaient avec « Moyens de paiement » sans que rien ne dise ce qui allait
 * ensemble. Sept entrées de premier niveau les remplacent.</p>
 *
 * <p>Une entrée peut déclarer une <b>permission</b> : elle n'apparaît alors que
 * si le jeton la porte. Un groupe dont tous les enfants sont refusés disparaît
 * avec eux — voir <c>SidebarService.checkSidebarLinks</c>.</p>
 *
 * <p>Le champ <b>screen</b> nomme la destination quand plusieurs chemins mènent
 * au même écran : c'est sur lui que porte le dédoublonnage, et non sur l'URL.</p>
 */
export const ADMIN_LINKS = [
  {
    id: '1',
    name: 'SIDEBAR.DASHBOARD',
    icon: 'fa-solid fa-house ms-2',
    link: '/admin/dashboard',
  },

  // Qui fréquente l'école : ceux qui enseignent, ceux qui apprennent, et la
  // façon dont on les rassemble.
  {
    id: 'people',
    name: 'SIDEBAR.GROUP_PEOPLE',
    icon: 'fa-solid fa-users ms-2',
    link: '/admin/professors',
    hasSubmenu: true,
    submenu: [
      {
        id: 'people-professors',
        name: 'SIDEBAR.PROFESSORS',
        icon: 'fa-solid fa-user-tie',
        link: '/admin/professors',
        permission: 'professors.read',
      },
      {
        id: 'people-students',
        name: 'SIDEBAR.STUDENTS',
        icon: 'fa-solid fa-user-graduate',
        link: '/admin/students',
        permission: 'students.read.all',
      },
      {
        // Juste après les élèves : c'est d'eux qu'il s'agit, pas des tests.
        id: 'people-following',
        name: 'FOLLOWING.ADMIN_TITLE',
        icon: 'fa-solid fa-chart-line',
        link: '/admin/student-following',
        role: 'supervisor',
      },
      {
        id: 'people-groups',
        name: 'SIDEBAR.ALL_GROUPS',
        icon: 'fa-solid fa-users-rectangle',
        link: '/admin/groups',
        permission: 'groups.read',
      },
    ],
  },

  // Le parcours d'un futur élève, de la demande au paiement.
  {
    id: 'enrolment',
    name: 'SIDEBAR.GROUP_ENROLMENT',
    icon: 'fa-solid fa-file-invoice-dollar ms-2',
    link: '/admin/registrations',
    hasSubmenu: true,
    submenu: [
      {
        id: 'enrolment-registrations',
        name: 'SIDEBAR.REGISTRATIONS',
        icon: 'fa-solid fa-file-signature',
        link: '/admin/registrations',
        permission: 'registrations.read',
      },
      {
        id: 'enrolment-packs',
        name: 'SIDEBAR.PACKS',
        icon: 'fa-solid fa-tags',
        link: '/admin/packs',
        // Sa propre permission depuis la scission de `registrations.*` :
        // l'une suffit, l'écran s'ouvre alors en consultation ou en modification.
        permission: 'packs.read',
      },
      {
        id: 'enrolment-payment-methods',
        name: 'SIDEBAR.PAYMENT_METHODS',
        icon: 'fa-solid fa-building-columns',
        link: '/admin/payment-methods',
        permission: 'payments.read',
      },
    ],
  },

  // Ce qui est enseigné : la hiérarchie parcours → matière → module, et les
  // supports qui l'accompagnent.
  {
    id: 'content',
    name: 'SIDEBAR.GROUP_CONTENT',
    icon: 'fa-solid fa-book-open ms-2',
    link: '/admin/learning-paths',
    hasSubmenu: true,
    submenu: [
      {
        id: 'content-learning-paths',
        name: 'SIDEBAR.LEARNING_PATHS',
        icon: 'fa-solid fa-route',
        link: '/admin/learning-paths',
        permission: 'referential.read',
      },
      {
        id: 'content-themes',
        name: 'SIDEBAR.THEMES',
        icon: 'fa-solid fa-layer-group',
        link: '/admin/themes',
        permission: 'referential.read',
      },
      {
        id: 'content-library',
        name: 'SIDEBAR.LIBRARY',
        icon: 'fa-solid fa-photo-film',
        link: '/admin/library',
        permission: 'library.read.all',
      },
    ],
  },

  // Ce qui mesure : les tests, leur matière première, leur relecture et les
  // barèmes qui les interprètent.
  {
    id: 'assessment',
    name: 'SIDEBAR.GROUP_ASSESSMENT',
    icon: 'fa-solid fa-file-pen ms-2',
    link: '/admin/tests',
    hasSubmenu: true,
    submenu: [
      {
        id: 'assessment-tests',
        name: 'ADMIN_TESTS.TITLE',
        icon: 'fa-solid fa-file-pen',
        link: '/admin/tests',
        permission: 'tests.read.all',
      },
      {
        id: 'assessment-question-bank',
        name: 'SIDEBAR.QUESTION_BANK',
        icon: 'fa-solid fa-database',
        link: '/admin/question-bank',
        permission: 'questions.read.all',
      },
      {
        id: 'assessment-review-queue',
        name: 'SIDEBAR.REVIEW_QUEUE',
        icon: 'fa-solid fa-clipboard-check',
        link: '/admin/review-queue',
        permission: 'questions.write.all',
      },
      {
        id: 'assessment-bands',
        name: 'EVAL_BANDS.TITLE',
        icon: 'fa-solid fa-chart-simple',
        link: '/admin/evaluation-bands',
        // La lecture ouvre l'écran, comme côté serveur ; l'écriture y débloque la saisie.
        permission: 'referential.read',
      },
    ],
  },

  // Le temps : le découpage de l'année et l'occupation des professeurs.
  {
    id: 'planning',
    name: 'SIDEBAR.GROUP_PLANNING',
    icon: 'fa-solid fa-calendar-days ms-2',
    link: '/admin/academic-periods',
    hasSubmenu: true,
    submenu: [
      {
        id: 'planning-periods',
        name: 'SIDEBAR.ACADEMIC_PERIODS',
        icon: 'fa-solid fa-calendar-days',
        link: '/admin/academic-periods',
        permission: 'referential.read',
      },
      {
        id: 'planning-calendar',
        name: 'ADMIN_CALENDAR.TITLE',
        icon: 'fa-solid fa-calendar-check',
        link: '/admin/calendar',
        permission: 'sessions.read.all',
      },
    ],
  },

  // Ce qui regarde le fonctionnement lui-même. L'inspection n'est pas ici :
  // c'est un espace à part, que le sélecteur ouvre à qui porte la permission —
  // un lien vers /inspector ferait basculer tout le menu, puisqu'il suit l'URL.
  {
    id: 'oversight',
    name: 'SIDEBAR.GROUP_OVERSIGHT',
    icon: 'fa-solid fa-user-shield ms-2',
    link: '/admin/activity',
    hasSubmenu: true,
    submenu: [
      {
        id: 'oversight-activity',
        name: 'ACTIVITY.TITLE',
        icon: 'fa-solid fa-clock-rotate-left',
        link: '/admin/activity',
        permission: 'activity.read.all',
      },
      {
        // Composer et attribuer les profils d'accès (SKILL2ERA-129).
        id: 'oversight-access',
        name: 'SIDEBAR.ACCESS',
        icon: 'fa-solid fa-user-shield',
        link: '/admin/access',
        role: 'supervisor',
      },
      {
        // Publier l'aide. La lire est une autre destination, plus bas.
        id: 'oversight-assistance',
        name: 'SIDEBAR.MANAGE_ASSISTANCE',
        icon: 'fa-solid fa-pen-to-square',
        link: '/admin/assistance',
        permission: 'assistance.write',
      },
    ],
  },

  // L'aide elle-même, en lecture : la page qu'ont les professeurs et les élèves,
  // à la même place dans leur menu. L'équipe y trouve ses propres procédures.
  {
    id: 'assistance',
    name: 'SIDEBAR.ASSISTANCE',
    icon: 'fa-solid fa-circle-question ms-2',
    link: '/admin/help',
    permission: 'assistance.read.all',
  },
];

/**
 * Le menu de l'espace Inspection.
 *
 * Un espace à part, ouvert par `sessions.inspect` : un professeur ou un
 * administrateur qui inspecte y passe par le sélecteur d'espace, et retrouve
 * son propre menu en revenant — rien n'est greffé sur l'autre.
 */
export const INSPECTOR_LINKS = [
  {
    id: 'inspection',
    name: 'SIDEBAR.INSPECTION',
    icon: 'fa-solid fa-clipboard-check ms-2',
    link: '/inspector/sessions',
    permission: 'sessions.inspect',
  },
  {
    id: 'inspection-calendar',
    name: 'SIDEBAR.CALENDAR',
    icon: 'fa-solid fa-calendar-days ms-2',
    link: '/inspector/calendar',
    permission: 'sessions.inspect',
  },
  {
    id: 'inspection-library',
    name: 'SIDEBAR.LIBRARY',
    icon: 'fa-solid fa-photo-film ms-2',
    link: '/inspector/library',
    permission: 'library.read.all',
  },
  {
    id: 'inspection-professors',
    name: 'SIDEBAR.PROFESSORS',
    icon: 'fa-solid fa-user-tie ms-2',
    link: '/inspector/professors',
    permission: 'professors.read',
  },
  {
    id: 'inspection-activity',
    name: 'SIDEBAR.MY_ACTIVITY',
    icon: 'fa-solid fa-list-check ms-2',
    link: '/inspector/activity',
    permission: 'activity.read.own',
  },
];
